<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div :class="{modalContent: true}">
        <h4>Article Selector</h4>
        <div class="tabCnt">
          <div class="tab tab1" :class="{active: tabActive === 'article'}"
            v-on:click="tabActive = 'article'">Article</div>
          <div class="tab tab1" :class="{active: tabActive === 'link'}"
            v-on:click="tabActive = 'link'">Link</div>
        </div>
        <div class="categoryCnt" v-if="tabActive === 'article'">
          <div class="fieldGroup">
            <input type="text" class="field" placeholder="Type article title..."
              v-on:input="search" v-model="q">
            <div class="searching" v-if="searching"></div>
          </div>
          <div class="productCnt" v-if="!searching && !typing && results.length < 1">
            <div class="noData" v-if="!q">Start typing to search article</div>
            <div class="noData" v-else>No article found qith query
              <b>"{{q}}"</b>
            </div>
          </div>
          <div class="productCnt" v-else>
            <div class="productItem" v-for="(item, i) in results" :key="`pa${i}`"
              v-on:click="close(true, item)">
              <div class="thumb" v-if="item.thumb[lang]"
                :style="{'background-image': `url(${item.thumb[lang]})`}">
              </div>
              <div class="thumb noImg" v-else></div>
              <h4>{{item.title[lang]}}</h4>
              <p v-if="item.description[lang]">{{item.description[lang].substr(0, 120)}}{{
                (item.description[lang].length > 120) ? '...' : ''
              }}</p>
            </div>
          </div>
        </div>
        <div class="linkCnt" v-else>
          <div class="fieldGroup">
            <div class="pdfCover" v-on:click="addImage">
              <div class="thePdf" v-if="media">
                <div class="coverImg" :style="{'background-image': `url(${cover.imageMd})`}"
                  v-if="cover"/>
                <div class="coverImg" :style="{'background-image': `url(${media.imageMd})`}"
                  v-else-if="media.type === 'image'"/>
                <div class="coverImg" :style="{'background-image': `url(${media.thumb})`}"
                  v-else-if="media.mimetype === 'video/youtube'"/>
                <div class="coverImg" :style="{'background-image': `url(${media.mainThumb})`}"
                  v-else-if="media.type === 'video'"/>
                <div class="coverImg" :style="{'background-image': `url(${media.cover})`}"
                  v-else-if="media.type === 'pdf'"/>
                <div class="pdfOption" v-if="media.type === 'video'">
                  <div class="optBtn" v-on:click.stop="showPdfOptions = true"></div>
                  <div class="optOverlay" v-on:click.stop="showPdfOptions = false"
                    v-if="showPdfOptions"></div>
                  <div class="optCnt" v-if="showPdfOptions">
                    <li v-on:click="showPdfOptions = false">Change Media</li>
                    <li v-on:click.stop="customCover">Custom Cover Image</li>
                    <li v-on:click.stop="cover = null; showPdfOptions = false">
                      Reset Default Cover</li>
                  </div>
                </div>
              </div>
              <div class="addPdf" v-else>
                Add Media
              </div>
            </div>
          </div>
          <div class="fieldGroup">
            <div class="fieldCnt">
              <label>Title</label>
              <input type="text" placeholder="Title..." class="field"
                v-model="form.title.model">
            </div>
          </div>
          <div class="fieldGroup">
            <div class="fieldCnt">
              <label>Descriptions</label>
              <textarea rows="2" type="text" placeholder="Descriptions..." class="field"
                v-model="form.description.model"></textarea>
            </div>
          </div>
          <div class="fieldGroup">
            <div class="fieldCnt">
              <label>Url</label>
              <input type="text" placeholder="https://..." class="field"
                v-model="form.url.model">
            </div>
          </div>
          <div class="modalAction">
            <button class="btn btnSecondary" type="button"
              v-on:click="close(false)">Cancel</button>
            <button class="btn btnPrimary" type="submit"
              v-on:click="handleSubmit">
              <span>Save</span>
            </button>
          </div>
        </div>
      </div>
      <MediaSelector ref="mediaSelector"/>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';
import MediaSelector from '@/components/MediaSelector.vue';

export default {
  name: 'confirmation',
  components: { MediaSelector },
  data() {
    return {
      show: false,
      next: null,
      results: [],
      searching: false,
      searchTimer: null,
      tabActive: 'article',
      typing: false,
      q: '',
      media: null,
      cover: null,
      form: {
        title: { model: '' },
        description: { model: '' },
        url: { model: '' },
      },
    };
  },
  computed: {
    ...mapState(['lang']),
  },
  methods: {
    open(d, next) {
      this.show = true;
      this.next = next;
      this.typing = false;
      this.searching = false;
      this.form.title.model = d && d.type === 'custom_link' ? d.title : '';
      this.form.description.model = d && d.type === 'custom_link' ? d.description : '';
      this.form.url.model = d && d.type === 'custom_link' ? d.url : '';
      this.media = d && d.type === 'custom_link' ? d.media : null;
      this.cover = d && d.type === 'custom_link' ? d.cover : null;
      this.tabActive = d && d.type === 'custom_link' ? 'link' : 'article';
      document.getElementsByTagName('BODY')[0].classList.add('stopscroll');
    },
    close(b, v) {
      this.show = false;
      document.getElementsByTagName('BODY')[0].classList.remove('stopscroll');
      if (this.next && typeof this.next === 'function') this.next(b, v);
    },
    customCover() {
      this.showPdfOptions = false;
      this.$refs.mediaSelector.open({ type: 'image' }, (b, media) => {
        if (b) this.cover = media;
      });
    },
    addImage() {
      this.$refs.mediaSelector.open(null, (b, media) => {
        if (!b) return;
        this.cover = null;
        this.media = media;
      });
    },
    handleSubmit() {
      const formData = {
        type: 'custom_link',
        title: this.form.title.model,
        description: this.form.description.model,
        url: this.form.url.model,
        media: this.media,
        cover: this.cover,
      };
      this.close(true, formData);
    },
    search(e) {
      const q = e.target.value;
      if (!q || q === '') {
        this.results = [];
        this.searching = false;
        this.typing = false;
        return;
      }
      this.typing = true;
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.searching = true;
        this.$http.get(this.$config.uri(`article/autocomplete?qa=${q}`)).then((r) => {
          this.searching = false;
          this.results = (r.data.status === 200) ? r.data.data : [];
        });
      }, 500);
    },
  },
};
</script>

<style scoped lang="scss">
.pdfCover{
  height: 180px;
  background-color: #eee;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 24px;
  cursor: pointer;
  position: relative;
  .thePdf{
    position: absolute;
    left: 0; top: 0; right: 0; bottom: 0;
    border-radius: 5px;
    .coverImg{
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      border-radius: 5px;
      z-index: 1;
    }
    .pdfOption{
      position: absolute;
      right: 10px; top: 10px;
      z-index: 2;
      .optBtn{
        width: 34px; height: 34px;
        background-color: #fff;
        border-radius: 50%;
        position: relative;
        box-shadow: 2px 2px 4px rgba(0,0,0,.1);
        &:hover{
          background-color: #f5f5fe;
        }
        &:before{
          position: absolute;
          content: "";
          left: 0; right: 0; top: 0; bottom: 0;
          background-image: url(../assets/more.png);
          background-size: 16px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
      .optOverlay{
        position: fixed;
        left: 0; top: 0; right: 0; bottom: 0;
        cursor: default;
        z-index: 1;
      }
      .optCnt{
        position: absolute;
        right: 0; top: 100%;
        background-color: #fff;
        box-shadow: 2px 2px 4px rgba(0,0,0,.2);
        border-radius: 5px;
        padding: 10px 0;
        z-index: 2;
        li{
          list-style: none;
          padding: 6px 20px;
          cursor: pointer;
          font-size: 15px;
          white-space: nowrap;
          &.divider{
            background-color: #eee !important;
            height: 1px;
            padding: 0;
            margin: 5px 0;
          }
          &.red{
            color: red;
          }
          &:hover{
            background-color: #f5f5fe;
          }
        }
      }
    }
  }
  .addPdf{
    font-size: 20px;
    color: #888;
    padding-top: 50px;
    position: relative;
    transition: color .3s ease;
    &:before{
      top: 0; left: 0; right: 0;
      height: 40px;
      content: "";
      transition: opacity .3s ease;
      position: absolute;
      background-image: url(../assets/image-black.png);
      background-size: 40px auto;
      background-position: center top;
      background-repeat: no-repeat;
      opacity: .3;
    }
  }
  transition: background-color .3s ease;
  &:hover{
    background-color: #e5e5e5;
    .addPdf{
      color: #767676;
      &:before{
        opacity: .5;
      }
    }
  }
}

.modal{
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 99991;
  display: flex;
  align-items: center;
  justify-content: center;
  .modalOverlay{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background-color: rgba(0,0,0,.7);
    z-index: 1;
    // backdrop-filter: saturate(180%) blur(20px);
    opacity: 1;
  }
  .modalContent{
    position: absolute;
    background-color: #fff;
    z-index: 2;
    padding: 30px 40px;
    border-radius: 5px;
    margin-top: -20px;
    overflow: hidden;
    width: 420px;
    &.hasCheck{
      text-align: left;
    }
    h4{
      margin: -30px -40px 0;
      padding: 14px 40px 10px;
      border-bottom: #eee 1px solid;
      font-size: 24px;
      font-weight: 600;
      color: #444;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .tabCnt{
      margin: 0 -80px 0;
      padding: 0 90px;
      display: none;
      .tab{
        width: auto;
        padding: 10px 0;
        background-color: #fff;
        margin-right: 30px;
        &:after{
          left: -10px; right: -10px;
        }
      }
    }
    .categoryCnt{
      padding: 10px 40px;
      margin: 0 -40px;
      .fieldGroup{
        position: relative;
        margin-bottom: 10px;
        &:before{
          content: "";
          width: 40px; height: 40px;
          position: absolute;
          left: 4px; top: -1px;
          opacity: .36;
          background-image: url(../assets/search.png);
          background-size: 18px auto;
          background-position: center;
          background-repeat: no-repeat;
          z-index: 3;
        }
        .field{
          border-radius: 50px;
          padding: 8px 42px;
        }
        .searching{
          width: 40px; height: 40px;
          position: absolute;
          right: 4px; top: -1px;
          background-image: url(../assets/loading-2.svg);
          background-size: 26px auto;
          background-position: center;
          background-repeat: no-repeat;
          z-index: 3;
        }
      }
      .productCnt{
        border-top: #eee 1px solid;
        border-bottom: #eee 1px solid;
        min-height: 40vh;
        max-height: 54vh;
        overflow-y: auto;
        margin: 0 -40px -30px;
        padding: 0;
        .noData{
          padding: 14px 40px;
          color: #999;
          font-style: italic;
        }
        .productItem{
          position: relative;
          min-height: 64px;
          box-sizing: border-box;
          padding: 12px 40px;
          padding-left: 106px;
          cursor: pointer;
          transition: all .3s ease;
          &:hover{
            background-color: #f5f5fe;
          }
          .thumb{
            left: 40px;
            top: 16px;
            position: absolute;
            width: 48px;
            height: 48px;
            // height: 80px;
            // top: 20px;
            background-color: #e5e5e5;
            // background-color: #fff;
            background-size: cover;
            background-position: top center;
            background-repeat: no-repeat;
            border-radius: 4px;
            opacity: 1;
            display: inline-block;
            &.noImg{
              background-image: url(../assets/image-white.png);
              background-size: 24px auto;
              background-position: center;
              background-repeat: no-repeat;
            }
          }
          h4{
            margin: 0;
            padding: 0;
            border: none;
            font-size: 17px;
            font-weight: 600;
          }
          p{
            margin: 0;
            color: #767676;
            font-size: 15px;
            line-height: 1.23;
          }
        }
      }
    }
    .linkCnt{
      padding: 20px 0 0;
      .modalAction{
        margin-top: 60px;
      }
    }
    p{
      margin: 0;
      color: #767676;
    }
    .modalAction{
      margin: 0 -40px -30px;
      padding: 10px 20px;
      text-align: right;
      // background-color: #eee;
      border-top: #eee 1px solid;
      .btn{
        margin-left: 10px;
        &.disabled{
          background-color: #ddd;
          color: #999;
          box-shadow: none;
          cursor: default;
        }
      }
    }
  }
}
</style>
